import Resource from '@/api/resources/Resource'

class PatientNotesService extends Resource {
    async findById(patientId) {
        return this.axios.get(`/patients/${patientId}/notes`)
            .then(response => response.data)
    }

    async update(patientId, clob) {
        return this.axios.put(`/patients/${patientId}/notes`, clob)
            .then(response => response.data)
    }
}

export default new PatientNotesService()
